export default __webpack_public_path__ + "static/download-kv-5a89570e799794b24265a9cd2ed6da8d.jpg";